import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.BASE_URL, 
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjMsImVtYWlsIjoiYm9zc0BnbWFpbC5jb20iLCJ1c2VyVHlwZSI6Ik1haW4gQWRtaW4iLCJpYXQiOjE3NDQ0ODM5MzIsImV4cCI6MTc5NjMyMzkzMn0.A2vTIp_T1EH9RWpof-a3IsMzcA7ONv4qo49-d0hkZVQ';
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
